export default {
  Query: {
    fields: {
      breadcrumbs(_, { args, toReference }) {
        return toReference({ __typename: 'Directory', id: args.id });
      },
    },
  },
};
